/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDetail } from '../../models/content-detail';
import { CreateUpdateContentRequest } from '../../models/create-update-content-request';

export interface CreateContentVersion$Params {

/**
 * ID sekcie
 */
  id: number;
      body?: CreateUpdateContentRequest
}

export function createContentVersion(http: HttpClient, rootUrl: string, params: CreateContentVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDetail>> {
  const rb = new RequestBuilder(rootUrl, createContentVersion.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDetail>;
    })
  );
}

createContentVersion.PATH = '/admin/content/{id}/version';
